import { IconAdd } from '@consta/icons/IconAdd'
import { Button } from '@consta/uikit/Button'
import {
  selectProjectWellVspByIds,
  setActiveProjectVsp,
  useAppDispatch,
  useAppSelector,
} from '@core/core/store'
import type { ProjectId } from 'common/types'
import type { FC } from 'react'

import {
  extractFilterFormContext,
  extractWellIdContext,
  NotFoundSpeedLawInWell,
  useStepController,
  useStepControllerMethods,
  VspOffset,
  VspTable,
} from '../../components'
import type { OnApplyVspFunc, OnChangeVspOffsetFunc, OnSwitchActiveVspFunc } from '../../types'
import css from './StepWellVspSettings.css'

type StepWellVspSettingsProps = {
  projectId: ProjectId
  onChangeVspOffset: OnChangeVspOffsetFunc
}

export const StepWellVspSettings: FC<StepWellVspSettingsProps> = ({
  projectId,
  onChangeVspOffset,
}) => {
  const { activeStep } = useStepController()
  const { addNextStep, getStep } = useStepControllerMethods()

  const wellId = extractWellIdContext(activeStep)
  const form = extractFilterFormContext(getStep('chooseBaseWell'))

  const dispatch = useAppDispatch()
  const wellsVsp = useAppSelector(state => selectProjectWellVspByIds(state, [wellId]))
  const wellVsp = wellsVsp.at(0)

  const onAttachVspClick: OnApplyVspFunc =
    ({ vspId, vspName }) =>
    () => {
      addNextStep(vspName, 'chooseTargetWells', {
        vspId,
        fieldId: null,
        filter: 'all',
        searchQuery: null,
      })
    }

  const onAddVspClick = () => {
    addNextStep('Добавить', 'chooseWellWithVsp')
  }

  if (!wellVsp || wellVsp.vspList.length === 0) {
    return <NotFoundSpeedLawInWell onActionClick={onAddVspClick} />
  }

  const activeVsp = wellVsp.vspList.find(vsp => vsp.isActive)

  const onOffset = activeVsp ? onChangeVspOffset(activeVsp.id, wellVsp.wellId) : undefined
  const onSetActiveProjectVsp: OnSwitchActiveVspFunc = (vspId, isActive) => () => {
    if (wellId && form?.fieldId && !isActive) {
      dispatch(setActiveProjectVsp(projectId, wellId, vspId))
    }
  }

  return (
    <>
      <VspOffset offset={activeVsp?.offset} withLabel={true} onOffset={onOffset} />
      <VspTable
        wellVsp={wellVsp}
        actionLabel="Применить к скважинам"
        onSetActiveProjectVsp={onSetActiveProjectVsp}
        onApplyVsp={onAttachVspClick}
      />
      <div className={css.addVsp}>
        <Button
          size="xs"
          label="Добавить скоростной закон"
          view="ghost"
          iconLeft={IconAdd}
          iconSize="xs"
          onClick={onAddVspClick}
        />
      </div>
    </>
  )
}
